/**
 * @generated SignedSource<<2149fddbe3c9d14f3e783b38c0097b4a>>
 * @relayHash 11b4c43d44a151b17d93a6a704c6b2d3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e085255a6589f6a541a4ea97ba4005b1c720164491f6a21ead21951060fedd9c

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraProjectStyle = "COMPANY_MANAGED_PROJECT" | "TEAM_MANAGED_PROJECT" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type LevelUpSettingsQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type LevelUpSettingsQuery$data = {
  readonly codeInJira: {
    readonly " $fragmentSpreads": FragmentRefs<"ConfigurationSection_codeInJira">;
  };
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"ConfigurationSection_jira">;
  };
  readonly jira_projectByIdOrKey: {
    readonly created: AGG$DateTime | null | undefined;
    readonly projectStyle: JiraProjectStyle | null | undefined;
    readonly projectType: JiraProjectType | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"AutomationsSection" | "ConfigurationSection_project">;
  };
};
export type LevelUpSettingsQuery = {
  response: LevelUpSettingsQuery$data;
  variables: LevelUpSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectKey"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "idOrKey",
    "variableName": "projectKey"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "created"
},
v4 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v5 = {
  "kind": "ScalarField",
  "name": "projectStyle"
},
v6 = [
  (v1/*: any*/)
],
v7 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "LevelUpSettingsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v2/*: any*/),
          "concreteType": "JiraProject",
          "kind": "LinkedField",
          "name": "jira_projectByIdOrKey",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            {
              "kind": "FragmentSpread",
              "name": "AutomationsSection"
            },
            {
              "kind": "FragmentSpread",
              "name": "ConfigurationSection_project"
            }
          ]
        },
        "action": "THROW",
        "path": "jira_projectByIdOrKey"
      },
      {
        "kind": "RequiredField",
        "field": {
          "args": (v6/*: any*/),
          "concreteType": "CodeInJira",
          "kind": "LinkedField",
          "name": "codeInJira",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "ConfigurationSection_codeInJira"
            }
          ]
        },
        "action": "THROW",
        "path": "codeInJira"
      },
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "ConfigurationSection_jira"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LevelUpSettingsQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jira_projectByIdOrKey",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "ScalarField",
            "name": "key"
          },
          (v7/*: any*/)
        ]
      },
      {
        "args": (v6/*: any*/),
        "concreteType": "CodeInJira",
        "kind": "LinkedField",
        "name": "codeInJira",
        "plural": false,
        "selections": [
          {
            "concreteType": "CodeInJiraUserConfiguration",
            "kind": "LinkedField",
            "name": "userConfiguration",
            "plural": false,
            "selections": [
              {
                "concreteType": "CodeInJiraBitbucketWorkspace",
                "kind": "LinkedField",
                "name": "ownedBitbucketWorkspaces",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraDevOpsQuery",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "appId",
                    "value": "bitbucket"
                  },
                  (v1/*: any*/)
                ],
                "concreteType": "JiraAppConfigState",
                "kind": "LinkedField",
                "name": "configState",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraConfigStateConnection",
                    "kind": "LinkedField",
                    "name": "config",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraConfigState",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "appId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "status"
                          }
                        ]
                      }
                    ]
                  },
                  (v7/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e085255a6589f6a541a4ea97ba4005b1c720164491f6a21ead21951060fedd9c",
    "metadata": {},
    "name": "LevelUpSettingsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c71a7e6f91c987f1830414501fc3bdde";

export default node;
